import { render, staticRenderFns } from "./aftersale_order_edit_location.vue?vue&type=template&id=d4c65fdc&scoped=true"
import script from "./aftersale_order_edit_location.vue?vue&type=script&lang=js"
export * from "./aftersale_order_edit_location.vue?vue&type=script&lang=js"
import style0 from "./aftersale_order_edit_location.vue?vue&type=style&index=0&id=d4c65fdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c65fdc",
  null
  
)

export default component.exports